// extracted by mini-css-extract-plugin
export var customOfferCardFoundation = "bb_dn";